import React from 'react';
import { resolveMediaUrl } from '../utils/format';
import { API_CONFIG } from '../config/api';

/**
 * MediaDisplay Component
 * Resim veya video URL'sini otomatik olarak algılayıp doğru tag'i render eder.
 * Lokal dev'de localhost:3000 ile gelen URL'ler backend serveFile'a yönlendirilir.
 */
const MediaDisplay = ({ 
  src, 
  alt = '', 
  className = '', 
  videoProps = {},
  imgProps = {},
  fallbackSrc = null 
}) => {
  if (!src && !fallbackSrc) {
    return null;
  }

  const rawSrc = src || fallbackSrc;
  const mediaSrc = resolveMediaUrl(rawSrc, API_CONFIG.BASE_URL);
  
  // Video formatlarını kontrol et
  const isVideo = mediaSrc.match(/\.(mp4|webm|ogg|avi|mov|wmv|mkv|flv)$/i);

  // Eğer className'de max-h belirtilmemişse, varsayılan olarak 80vh ekle
  const hasMaxHeight = className.includes('max-h');
  const finalClassName = hasMaxHeight 
    ? className 
    : `${className} max-h-[80vh]`.trim();

  if (isVideo) {
    return (
      <video
        src={mediaSrc}
        className={finalClassName}
        style={{
          maxHeight: hasMaxHeight ? undefined : '80vh',
          ...videoProps.style
        }}
        autoPlay
        loop
        muted
        playsInline
        {...videoProps}
      />
    );
  }

  return (
    <img
      src={mediaSrc}
      alt={alt}
      className={finalClassName}
      style={{
        maxHeight: hasMaxHeight ? undefined : '80vh',
        ...imgProps.style
      }}
      {...imgProps}
    />
  );
};

export default MediaDisplay;

